/* eslint-disable @typescript-eslint/no-floating-promises */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import PTBR from '../../public/locales/pt/pt-br.json'

const resources = {
  'pt-BR': PTBR,
}

const i18nInstance = i18n.createInstance()

i18nInstance.use(initReactI18next).init({
  lng: navigator.language,
  fallbackLng: 'pt-BR',
  resources,
})

export default i18nInstance
